jQuery(document).ready(function ($) {
    console.log("jquery document ready");
    var slider = $('.hero_slider');

    if (slider.length) {
        slider.slick({
            arrows: true,
            prevArrow: $('.hero_prev_arrow'),
            nextArrow: $('.hero_next_arrow'),
            dots: false,
            autoplay: true,
            slidesToShow: 1,
            autoplaySpeed: 6000,
            fade: true,
            pauseOnHover: false
        });
    }

    jQuery(".testimonial-slider").slick({
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 1,
        adaptiveHeight: true,
    });

    jQuery(window).on('scroll', function () {
        if (jQuery(this).scrollTop() > 60) {
            jQuery('header').addClass('sticky_header');
            jQuery('.header_top').addClass('sticky_header');
            jQuery('.header_menu').addClass('sticky_header');
        } else {
            jQuery('header').removeClass('sticky_header');
            jQuery('.header_top').removeClass('sticky_header');
            jQuery('.header_menu').removeClass('sticky_header');
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {

    // SEARCH BAR TOGGLE
    const searchIcons = document.querySelectorAll(".search_icon");
    const searchBar = document.getElementById("searchBar");
    const closeSearchBar = document.getElementById("closeSearchBar");

    searchIcons.forEach(icon => {
        icon.addEventListener("click", function () {
            searchBar.classList.add("search_bar_open");
            document.body.style.overflowY = "hidden";
        });
    });


    closeSearchBar.addEventListener("click", function () {
        searchBar.classList.remove("search_bar_open");
        document.body.style.overflowY = "auto";
    });


    // MEGA MENU TOGGLE
    const menuItems = document.querySelectorAll(".nav > li");
    const megaMenu = document.getElementById("header_mega_menu");

    menuItems.forEach(item => {

        item.addEventListener("mouseenter", function () {
            const subMenu = item.querySelector(".sub-menu");

            if (subMenu) {
                megaMenu.innerHTML = "";
                megaMenu.appendChild(subMenu.cloneNode(true));
                megaMenu.classList.add("open");
            } else {
                megaMenu.innerHTML = "";
                megaMenu.classList.remove("open");
            }
        });

    });

    megaMenu.addEventListener("mouseleave", function () {
        megaMenu.classList.remove("open");
        megaMenu.innerHTML = "";
    });


    // MOBILE MENU TOGGLE
    if (window.innerWidth < 991) {

        const mobileMenuBtn = document.getElementById("mobileMenuBtn");
        const headerMenu = document.querySelector(".header_menu .nav");
        const header = document.getElementById("mainHeader");

        function updateMenuPosition() {
            const headerHeight = header.offsetHeight;
            const menuHeight = window.innerHeight - headerHeight;

            headerMenu.style.top = headerHeight + "px";
            headerMenu.style.height = menuHeight + "px";
        }

        mobileMenuBtn.addEventListener("click", function () {
            const isOpen = headerMenu.classList.toggle("menu_open");

            updateMenuPosition();

            if (isOpen) {
                document.body.style.overflowY = "hidden";
            } else {
                document.body.style.overflowY = "auto";
            }
        });

        window.addEventListener("resize", updateMenuPosition);
        window.addEventListener("scroll", updateMenuPosition);
        const menuItems = headerMenu.querySelectorAll("li");

        menuItems.forEach(li => {
            const submenu = li.querySelector(":scope > ul");

            if (submenu) {
                li.classList.add("has-submenu");

                const parentLink = li.querySelector(":scope > a");

                parentLink.addEventListener("click", function (e) {
                    e.preventDefault(); 
                    li.classList.toggle("submenu_open");
                });
            }
        });

    }
    // Reveal on scroll
    function reveal() {
            var reveals = document.querySelectorAll(".reveal");
            for (var i = 0; i < reveals.length; i++) {
                var windowHeight = window.innerHeight;
                var elementTop = reveals[i].getBoundingClientRect().top;
                var elementVisible = 150;
                if (elementTop < windowHeight - elementVisible) {
                    reveals[i].classList.add("reaveal_item");
                } else {
                    reveals[i].classList.remove("reaveal_item");
                }
            }
    }
    window.addEventListener("scroll", reveal);
    reveal();

    // ACCordion
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('.accordion_toggle');
        if (!btn) return;

        const section = btn.closest('.collapsible_content');
        if (!section) return;

        section.classList.toggle('is-closed');

        const isClosed = section.classList.contains('is-closed');
        btn.setAttribute('aria-expanded', String(!isClosed));
    });

    document.querySelectorAll('.collapsible_content').forEach((section) => {
        const btn = section.querySelector('.accordion_toggle');
        if (!btn) return;

        const isClosed = section.classList.contains('is-closed');
        btn.setAttribute('aria-expanded', String(!isClosed));
    });

});

